import { clientApp } from './index';

export const getApps = () => clientApp.get(`/ui/user/apps`);

export const putApps = (data = []) => clientApp.put(`/ui/user/apps`, data);
